export const fdi = {
    // upper right side 
    18: {
        palmer: "UR8",
        fdi: 18,
        universal: 1
    },

    17: {
        palmer: "UR7",
        fdi: 17,
        universal: 2
    },

    16: {
        palmer: "UR6",
        fdi: 16,
        universal: 3
    },

    15: {
        palmer: "UR5",
        fdi: 15,
        universal: 4
    },

    14: {
        palmer: "UR4",
        fdi: 14,
        universal: 5
    },

    13: {
        palmer: "UR3",
        fdi: 13,
        universal: 6
    },

    12: {
        palmer: "UR2",
        fdi: 12,
        universal: 7
    },

    11: {
        palmer: "UR1",
        fdi: 11,
        universal: 8
    },
    10: {
        palmer: "UL1",
        fdi: 21,
        universal: 9
    },

    // upper left side 

    21: {
        palmer: "UL1",
        fdi: 21,
        universal: 9
    },

    22: {
        palmer: "UL2",
        fdi: 22,
        universal: 10
    },

    23: {
        palmer: "UL3",
        fdi: 23,
        universal: 11
    },

    24: {
        palmer: "UL4",
        fdi: 24,
        universal: 12
    },

    25: {
        palmer: "UL5",
        fdi: 25,
        universal: 13
    },

    26: {
        palmer: "UL6",
        fdi: 26,
        universal: 14
    },

    27: {
        palmer: "UL7",
        fdi: 27,
        universal: 15
    },

    28: {
        palmer: "UL8",
        fdi: 28,
        universal: 16
    },


    // lower left side 

    38: {
        palmer: "LL8",
        fdi: 38,
        universal: 17
    },

    37: {
        palmer: "LL7",
        fdi: 37,
        universal: 18
    },

    36: {
        palmer: "LL6",
        fdi: 36,
        universal: 19
    },

    35: {
        palmer: "LL5",
        fdi: 35,
        universal: 20
    },

    34: {
        palmer: "LL4",
        fdi: 34,
        universal: 21
    },

    33: {
        palmer: "LL3",
        fdi: 33,
        universal: 22
    },

    32: {
        palmer: "LL2",
        fdi: 32,
        universal: 23
    },

    31: {
        palmer: "LL1",
        fdi: 31,
        universal: 24
    },



    // lower right side 
    40: {
        palmer: "LL1",
        fdi: 31,
        universal: 24
    },
    41: {
        palmer: "LR1",
        fdi: 41,
        universal: 25
    },

    42: {
        palmer: "LR2",
        fdi: 42,
        universal: 26
    },

    43: {
        palmer: "LR3",
        fdi: 43,
        universal: 27
    },

    44: {
        palmer: "LR4",
        fdi: 44,
        universal: 28
    },

    45: {
        palmer: "LR5",
        fdi: 45,
        universal: 29
    },

    46: {
        palmer: "LR6",
        fdi: 46,
        universal: 30
    },

    47: {
        palmer: "LR7",
        fdi: 47,
        universal: 31
    },

    48: {
        palmer: "LR8",
        fdi: 48,
        universal: 32
    },


}